import { render, staticRenderFns } from "./TheContainer.vue?vue&type=template&id=588b1f68"
import script from "./TheContainer.vue?vue&type=script&lang=js"
export * from "./TheContainer.vue?vue&type=script&lang=js"
import style0 from "./TheContainer.vue?vue&type=style&index=0&id=588b1f68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports